import { useEffect, useState } from 'react';
import StatCard from './stat-card';
import { axiosInstanceB2B } from '@share/utils';
import { connect, useSelector } from 'react-redux';
import { Spin } from 'antd';
import moment from 'moment';
import { ILoginState } from '@share/store/slices';
import { FormattedMessage, useIntl } from 'react-intl';

interface IMapStateToProps {
  loginStore: ILoginState;
}

export class IStadistics {
  spend: number = 0;
  savings: number = 0;
  avgNightlyRate: number = 0;
  roomsBooked: number = 0;
}

export interface IStadisticsDate {
  fromDate: string;
  toDate: string;
}

export enum IStadisticsFilters {
  SEVEN_DAYS = 'SEVEN_DAYS',
  THIRTY_DAYS = 'THIRTY_DAYS',
  NINETY_DAYS = 'NINETY_DAYS'
}

function RecentActivityComponent() {
  const loginStore = useSelector((state: IMapStateToProps) => state.loginStore);
  const [selectedFilter, setSelectedFilter] = useState<string>(IStadisticsFilters.SEVEN_DAYS)
  const [stadistics, setStadistics] = useState<IStadistics>(new IStadistics());
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    handleFilter(selectedFilter);
  }, []);

  const fetchData = async (toDate: string, fromDate: string) => {
    try {
      setLoading(true);
      const data = { toDate, fromDate };
      const response = await axiosInstanceB2B.post('/bookings/dashboard/recentactivity', data);
      setStadistics(response.data);
      setLoading(false);
    } catch (error: any) {
      console.error(error)
    }
    setLoading(false);
  };

  const handleFilter = async (selected: string) => {
    setSelectedFilter(selected);
    const value = selected as IStadisticsFilters;
    const diff = IStadisticsFilters.SEVEN_DAYS === value ? -7 : IStadisticsFilters.THIRTY_DAYS === value ? -30 : IStadisticsFilters.NINETY_DAYS === value ? -90 : -7;
    const toDate = moment().format('yyyy-MM-DD');
    const fromDate = moment().add(diff, 'days').format('yyyy-MM-DD');
    fetchData(toDate, fromDate);
  }
  const intl = useIntl();

  return (
    <section className="py-0 py-lg-7 px-15">
      <div className="container vstack gap-4">
        <div className="row">
          <div className="col-12">
            <h1 className="fs-4 mb-0">
              <i className="bi bi-graph-up-arrow fa-fw me-1"></i><FormattedMessage id="dashboard.activity.title" />
            </h1>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <Spin spinning={loading}>
              <div className="card border h-100">
                <div className="card-header border-bottom">
                  <div className="row d-flex justify-content-between align-items-center">
                    <div className="col-md-12 col-xl-6 mb-3 mb-md-0">
                      <h5 className="card-header-title">{loginStore?.account?.name}, <FormattedMessage id="dashboard.activity.desctiption" /></h5>
                    </div>
                    <div className="col-md-12 col-xl-2">
                        <select value={selectedFilter} onChange={(e) => handleFilter(e.target.value)} className="form-select form-select-sm js-choice border-0">
                        <option disabled>
                        {intl.formatMessage({ id: 'dashboard.activity.timeframe' })}
                      </option>
                      <option value={IStadisticsFilters.SEVEN_DAYS}>
                        {intl.formatMessage(
                          { id: 'dashboard.activity.timeframe.options' },
                          { value: 7 }
                        )}
                      </option>
                      <option value={IStadisticsFilters.THIRTY_DAYS}>
                        {intl.formatMessage(
                          { id: 'dashboard.activity.timeframe.options' },
                          { value: 30 }
                        )}
                      </option>
                      <option value={IStadisticsFilters.NINETY_DAYS}>
                        {intl.formatMessage(
                          { id: 'dashboard.activity.timeframe.options' },
                          { value: 90 }
                        )}
                      </option>
                        </select>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row g-4">
                    <StatCard key={1} {...{ iconClass: "bi bi-credit-card", isMoney: true, value: `${stadistics?.spend || '0'}`, label: `${intl.formatMessage({ id: 'dashboard.stats.amountSpent' })}`}} />
                    <StatCard key={2} {...{ iconClass: "bi bi-bank", isMoney: true, value: `${stadistics?.savings || '0'}`, label: `${intl.formatMessage({ id: 'dashboard.stats.savings' })}`, style: `${stadistics?.savings > 0 ? 'text-success' : ''}` }} />
                    <StatCard key={3} {...{ iconClass: "bi bi-calculator", isMoney: true, value: `${stadistics?.avgNightlyRate || '0'}`, label: `${intl.formatMessage({ id: 'dashboard.stats.avgNightlyRate' })}` }} />
                    <StatCard key={4} {...{ iconClass: "bi bi-calendar-check", isMoney: false, value: `${stadistics?.roomsBooked || '0'}`, label: `${intl.formatMessage({ id: 'dashboard.stats.nightsBooked' })}` }} />
                  </div>
                </div>
              </div>
            </Spin>
          </div>
        </div>
      </div>
    </section>
  );
};

const RecentActivity = connect()(RecentActivityComponent);
export { RecentActivity };